import '../style/contact-us/Info.scss';

const Info=()=>{
  return(
    <div className="info">
      <div className="info-item">
        <div className="info-item-title">آدرس ما</div>
        <div className="info-item-subtitle">
          تهران خیابان انقلاب بین ابوریحان و فلسطین بن بست سروش پلاک 2
        </div>
      </div>
      <div className="info-item">
        <div className="info-item-title">شماره تماس</div>
        <div className="info-item-subtitle">
          02163462405 - 02163462406
        </div>
      </div>
      <div className="info-item">
        <div className="info-item-title">شماره پیامک</div>
        <div className="info-item-subtitle">
          300000000008762144<br/>
          توجه داشته باشید تمامی پیامک ها از سامانه آزمون از طریق همین سرشماره برای شما ارسال خواهد شد
        </div>
      </div>
      <div className="info-item">
        <div className="info-item-title">ایمیل سازمانی</div>
        <div className="info-item-subtitle">
          Info@Azmoonsample.ir
        </div>
      </div>
    </div>
  )
}

export default Info;